/**
 * Returns the current URL without any hash params, preserving query params
 */
export function getUrlWithoutHashParams(): string {
    return window.location.href.split('#')[0];
}
